module.exports = __webpack_public_path__ + "img/petkupa_logo_kek.4ffa28e3.png";